import React from 'react';
import styles from './index.module.less';
import { Modal } from 'antd';

interface IProps {
    handleClose: () => void;
}

function UpcomingUpdateModal(props: IProps) {
    const makeModalRender = () => (
        <div className={styles['upcoming-update-modal']}>
            <div className={styles.text}>
                老师正在加紧制作课程
                <br />
                请耐心等待~
            </div>
            <div className={styles.btn} onClick={() => props.handleClose()}>
                我知道了
            </div>
        </div>
    );

    return <Modal width={460} open={true} centered closable={false} footer={null} modalRender={makeModalRender}></Modal>;
}

export default UpcomingUpdateModal;
